import { css } from '@linaria/core';

const item = css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  padding-bottom: 20px;

  [data-layout-mode='list'] &:nth-child(even) {
    background-color: #f9f6f4;
    margin-top: 0px;
    margin-right: -20px;
    margin-left: -20px;
    padding-right: 20px;
    padding-left: 20px;

    @media (min-width: 800px) {
      margin-right: 0px;
      padding-right: 0px;

      .${thumbnail} {
        margin-top: 20px;
      }
    }

    .${title}:not([data-featured-result=""]) {
      margin-top: 20px;
    }

    .${featuredLabel} {
      margin-top: 20px;
    }
  }

  [data-layout-mode='grid'] & {
    width: 100%;
    margin: 0;
    padding: 0;
    background-color: #ffff;
    border: 1px solid #e5dbd1;
    min-width: 0;
  }

  @media (min-width: 800px) {
    flex-direction: row;
    gap: 20px;
    justify-content: space-between;
    margin-top: 20px;
  }
`;

export const wrapperLink = css`
  display: block;
  width: 100%;
  text-decoration: none !important;
  transition: none !important;

  .${title} > span > * {
    color: #1a1a1a;
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }

  &:hover {
    .${title} > span > * {
      text-decoration-thickness: 3px;
    }
  }

  &:focus {
    background-color: inherit !important;
    box-shadow: none !important;
    color: inherit !important;

    .${title} > span > * {
      text-decoration: none;
      background-color: #fd0;
      box-shadow:
        0 0 #fd0,
        0 4px #1a1a1a;
      color: #1a1a1a;
    }
  }
`;

export const wrapper = css`
  width: 100%;
`;

export const thumbnail = css`
  margin-bottom: 10px;
  width: 100%;
  height: auto;
  max-width: 336px;
  max-height: 200px;
  object-fit: cover;

  [data-layout-mode='grid'] & {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0;
  }

  @media (min-width: 800px) {
    margin-bottom: 0;
    height: 160px;
    max-width: 160px;
  }

  @media (min-width: 1000px) {
    height: 150px;
    max-width: 150px;
  }

  @media (min-width: 1400px) {
    height: 200px;
    max-width: 200px;
  }
`;

export const defaultThumbnail = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  aspect-ratio: 1;
  background-color: #e6e6e6;
  box-sizing: border-box;

  & svg {
    width: 87px;
    height: 87px;
    fill: #b3b3b3;
  }

  @media (min-width: 800px) {
    [data-layout-mode='grid'] & {
      aspect-ratio: 1.4;
    }
  }
`;

export const title = css`
  display: block !important;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  margin: 0 0 10px;

  [data-layout-mode='grid'] & {
    font-size: 18px;
    line-height: 26px;
    padding: 20px 20px 0 20px;
  }

  [data-layout-mode='list'] & {
    margin-right: 20px;
  }

  @media (min-width: 800px) {
    font-size: 22px;
    line-height: 34px;
  }

  a,
  span {
    display: inline;
    font-weight: 700;
  }

  em {
    background-color: #b5e9f8;
    font-style: normal;
  }
`;

export const titleContents = css`
  display: block;
`;

export const attribute = css`
  padding-bottom: 10px;

  &:last-child {
    padding-bottom: 0;
  }

  [data-layout-mode='grid'] & {
    padding: 0 20px 10px 20px;

    &:last-child {
      padding: 0 20px 20px 20px;
    }
  }

  [data-layout-mode='list'] & {
    margin-right: 20px;
  }
`;

export const attributeLabel = css`
  display: inline;
  font-size: 16px;
  line-height: 26px;
  margin-right: 10px;
  font-weight: 400 !important;

  .search-ui [data-layout-mode='grid'] a & {
    text-decoration: none;
  }
`;

export const attributeValue = css`
  display: inline;
  font-size: 16px;
  line-height: 26px;
  font-weight: 600 !important;

  em {
    font-style: normal;
  }

  .search-ui [data-layout-mode='grid'] a & {
    text-decoration: none;
  }
`;

export const featuredLabel = css`
  background-color: #fdeec9;
  color: #1a1a1a;
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  padding: 2px 10px;
  margin-top: 5px;
  margin-bottom: 5px;
`;

export default function ResultView({ children }) {
  return <div className={item}>{children}</div>;
}
